import { Grid } from "@mui/material";
import React from "react";
import CollapseComponent from "../../../components/collapse/collapseComponent";
import { LoanInfo } from "../../../models/customer.model";
import CustomerLoanCard from "./CustomerLoanCard";

interface Props {
  loanInfo: LoanInfo[];
  handleDetail: Function;
}
const CustomerHeader = ({ loanInfo, handleDetail }: Props) => {
  return (
    <div>
      <CollapseComponent title="مشخصات تسهیلات">
        <Grid container gap={"15px"} flexDirection={"column"}>
          {loanInfo?.map((loan, index) => (
            <Grid
              item
              sx={{
                borderBottom:
                  index < loanInfo?.length - 1 ? "1px solid #C1C7CB" : "",
                paddingBottom: index < loanInfo?.length - 1 ? "10px" : "",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CustomerLoanCard
                loan={loan}
                key={index}
                handleDetail={handleDetail}
              />
            </Grid>
          ))}
        </Grid>
      </CollapseComponent>
    </div>
  );
};

export default CustomerHeader;
